import { Button } from '@heroui/react';

export const StyledButton = ({ block, ...rest }) => (
  <Button className={`bg-foreground/10 dark:bg-foreground/20 ${block ? 'w-full' : ''}`} {...rest} />
);
